import React from 'react'
import { Box, ListItemText, ListItemIcon, IconButton, Menu, MenuItem } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import { Link } from 'react-router-dom'
import { useAuth } from '../../api/context/UserAuthContext'
import { MENU } from './menu'

export const AdminXsMenu = () => {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const { user } = useAuth()

  const handleClose = () => setAnchorEl(null)

  const handleClick = (event) => setAnchorEl(event.currentTarget)

  const allowLinks = MENU.filter(({ permission }) => user?.permission.includes(permission))

  return (
    <Box display={{ xs: 'block', md: 'none' }}>
      <IconButton
        aria-label='more'
        aria-controls='long-menu'
        aria-haspopup='true'
        onClick={handleClick}
      >
        <MenuIcon />
      </IconButton>
      <Menu
        id='xs-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {allowLinks.map((each) => (
          <Link style={{ textDecoration: 'none', color: 'black' }} to={each.url} key={each.text}>
            <MenuItem onClick={handleClose}>
              <ListItemIcon>{each.icon}</ListItemIcon>
              <ListItemText primary={each.text} />
            </MenuItem>
          </Link>
        ))}
      </Menu>
    </Box>
  )
}
